import { Login, Logout } from '@mui/icons-material'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

import { CircularProgress, Dialog, DialogActions, DialogContent } from '@mui/material';
import moment from 'moment/moment';

import { useAlert } from '../../../../context/AlertContext';
import essAttendanceServices from '../essAttendanceServices';
import CalculateHours from '../../../../components/CalculateHours';
import useGeolocation from '../../../../hooks/useGeolocation';
import LocationTroubleshoot from './LocationTroubleshoot';
import { useAuth } from '../../../../context/AuthContext';
import { useEssAppData } from '../../../../context/AppESSDataContext';

function EssAttendance() {

    const {AppAlert} = useAlert();
    const {projectLocationDD,getDDDataById} = useEssAppData();
    const [saving,setSavingStatus] = useState(false);
    const [loading,setLoadingStatus] = useState(false);
    const [dialogStatus,setDialogStatus] = useState(false);

    const {authUser } = useAuth();

    const [lastPunch,setPunchDetails] = useState(null);

    const { getLocation, locatingLoading, geoLocationError,location } = useGeolocation();

    const getLastPunch = () =>{
        setLoadingStatus(true);
        essAttendanceServices.getLastPunch().then(res=>{
            console.log("Here in get punch details",res.data);
            setPunchDetails(res.data);
        }).catch(error=>{
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }

    const punchIn = () =>{
        setSavingStatus(true);
        essAttendanceServices.addPunch().then(res=>{
            AppAlert(res.msg);
        }).catch(error=>{
            AppAlert(error.msg,"error");
        }).finally(()=>{
            getLastPunch();
            setDialogStatus(false);
            setSavingStatus(false)
        })
    }

    const punchOut = () =>{
        setSavingStatus(true);
        essAttendanceServices.addPunch(lastPunch).then(res=>{
            AppAlert(res.msg);
        }).catch(error=>{
            AppAlert(error.msg,"error");
        }).finally(()=>{
            getLastPunch();
            setDialogStatus(false);
            setSavingStatus(false)
        })
    }


    useEffect(()=>{
        getLastPunch();
        getLocation();
    },[])

    const [distance,setDistance] = useState(0);
    const [projectLocationData,setProjectLocationData] = useState(null);

    useEffect(()=>{
        if(authUser.projectLocation !== null){
            let _projectLocationData = getDDDataById(projectLocationDD,authUser.projectLocation);
            setProjectLocationData(_projectLocationData);
        }
    },[authUser])


    const caluclateDistance = () =>{
        if(projectLocationData && location && projectLocationData.lat && projectLocationData.lng){
            let attendanceLocation = {
                lat:projectLocationData.lat,
                lng:projectLocationData.lng,
            }
            setDistance(essAttendanceServices.getDistanceInMeters(attendanceLocation,location))
        }
    }

    useEffect(()=>{
        caluclateDistance();
    },[location])

    return (
        <>

            {geoLocationError && 
                <div className="alert alert-danger" role="alert">
                    <h4 className="alert-heading">Error</h4>
                    <p> {geoLocationError}</p>
                    <hr/>
                    <LocationTroubleshoot/>
                </div>
            }

            {!geoLocationError &&
            <>
                <Dialog
                    open={dialogStatus}
                    keepMounted
                    onClose={()=>setDialogStatus(false)}
                    maxWidth="sm"
                >
                    <DialogContent>
                        { 
                            distance > projectLocationData?.radious ?
                                <div className="alert alert-danger" role="alert">
                                    <h4 className="alert-heading">Error</h4>
                                    <p> You are {distance / 1000} KM Away from your work Location </p>

                                    <p> You are should be around {projectLocationData.radious} meter away from your work location</p>
                                    <hr/>
                                    Punch Not Allowed
                                </div>
                            :
                            <div className="alert alert-success" role="alert">
                                    <h4 className="alert-heading">Confirm</h4>
                                    <p> You are {distance} Meter Away from your work Location</p>
                                    <hr/>
                                    <div>
                                    {!lastPunch ? 
                                        "Confirm Checkin"
                                        :
                                        "Are you sure you want to check out for today"
                                    }
                            </div>
                            </div>
                            
                        }
                    </DialogContent>
                    {distance <= projectLocationData?.radious &&
                    <DialogActions>
                        {!lastPunch ? 
                            <button className='btn btn-primary' onClick={punchIn}>Yes Check In</button>
                            :
                            <button className='btn btn-primary' onClick={punchOut}>Yes Check Out</button>
                        }
                        
                        <button className='btn btn-outline-primary' onClick={()=>setDialogStatus(false)}>No</button>
                    </DialogActions>
                    }

                </Dialog>
                <div className='card  p-3 '>                
                    {saving &&
                        <button className='btn btn-success text-white'   >
                            <CircularProgress className='text-white' />
                        </button>
                    }
                    { (!saving && !lastPunch) ?
                        <div className='text-center'>
                            <button onClick={()=>setDialogStatus(true)} className='btn btn-success'   >
                                <h3><Login style={{fontSize:60}} /></h3>
                                <p>Do Check In</p>
                            </button>
                        </div>
                        :
                        <div className='text-center'>
                            {lastPunch?.outTime ==null &&
                                <button onClick={()=>setDialogStatus(true)} className='btn btn-warning'   >
                                    <h3><Logout style={{fontSize:60}} /></h3>
                                    <p>Do Checkout</p>
                                </button>
                            }
                        </div>
                        
                    }
                    {!saving && lastPunch &&
                        <div className='row mt-2'>
                            <div className='col-md-4'>
                                <span className='fw-bold me-2'>In Time : </span>
                                {moment(lastPunch.inTime).format("LLL")}
                            </div>

                            <div className='col-md-4'>
                                {lastPunch.outTime ?
                                    <CalculateHours inTime={lastPunch.inTime} outTime={lastPunch.outTime} />
                                    :
                                    <CalculateHours inTime={lastPunch.inTime} />
                                }
                            </div>

                            <div className='col-md-4'>
                                <span className='fw-bold me-2'>Out Time : </span>
                                {lastPunch.outTime ?
                                    moment(lastPunch.outTime).format("LLL")
                                    :
                                    "----------"
                                }
                            </div>
                        </div>
                    }
                </div>
            </>
            }
        </>
    )
}

export default EssAttendance